/**
 * Política de cache do React Query compartilhada por `useDashboardMetrics` e
 * `usePerformanceData` (D10 — dash de Atendimento).
 *
 * As duas queries alimentam leituras que PRECISAM bater entre si: o card
 * "Atendimentos" mostra "criados", e a promessa da tela é que esse número
 * seja exatamente a soma da série `atendimentos` do gráfico logo abaixo. Se
 * os dois hooks tivessem `staleTime`/`refetchOnWindowFocus` diferentes, um
 * ficaria "correndo na frente" do outro entre refetches e os números
 * divergiriam sem nenhum erro de contagem — foi exatamente isso que
 * aconteceu antes desta mudança (metrics: 2min/focus-refetch; performance:
 * 5min/sem-refetch). Os valores abaixo são deliberadamente IDÊNTICOS nos
 * dois hooks — não diverja um do outro sem atualizar este comentário.
 */
export const DASHBOARD_QUERY_STALE_TIME_MS = 2 * 60 * 1000; // 2 minutes
export const DASHBOARD_QUERY_GC_TIME_MS = 5 * 60 * 1000; // 5 minutes
export const DASHBOARD_QUERY_REFETCH_ON_WINDOW_FOCUS = true;
